// extracted by mini-css-extract-plugin
export var navbarSubLink = "Z_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "Z_yx d_f0 d_dB";
export var subPageLink = "Z_gf d_gf";
export var burger = "Z_yB";
export var sublinkSize = "Z_yC";
export var linkSize = "Z_yD";
export var Link = "Z_wc K_wc K_vB K_vW";